import { render } from "./InputMobile.vue?vue&type=template&id=dc43d524"
import script from "./InputMobile.vue?vue&type=script&lang=js"
export * from "./InputMobile.vue?vue&type=script&lang=js"
script.render = render

export default script